import * as React from 'react'
import * as Styled from './ItemBank.styles'

const ItemBank = ({
  children,
  heading,
  backgroundColor = null,
  backgroundImage = null,
  mainContent = null,
  mobileBackgroundImage = null,
  mobileTextColor = null,
  textColor = null,
  stackItemsOnMobile,
  ...props
}) => (
  <Styled.Section
    className="leshen-item-bank"
    backgroundColor={backgroundColor}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    {...props}
  >
    {backgroundImage && (
      <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
        {backgroundImage}
      </Styled.BackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    <Styled.Content hasBackgroundImage={Boolean(backgroundImage)}>
      {mainContent}
    </Styled.Content>
    <Styled.Items
      hasBackgroundImage={Boolean(backgroundImage)}
      stackItemsOnMobile={Boolean(stackItemsOnMobile)}
    >
      {children}
    </Styled.Items>
  </Styled.Section>
)

export default ItemBank
